// Typelizer digest 2f23e4f5f08e5b24995bd2a2726dc77c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/teams/:team_id/invitations */
  index: (
    params: { teacherId: string | number; teamId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:team_id/invitations', params, options),
    method: 'get',
  }),

  /** PATCH /educators/teachers/:teacher_id/teams/:team_id/invitations/:id */
  update: (
    params: { teacherId: string | number; teamId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:team_id/invitations/:id', params, options),
    method: 'patch',
  }),
}
